module.exports = __webpack_public_path__ + "media/images/icons/icon_mypage_project-0f20e20b554cc3a3e483496b3d87fc48.svg";